import { motion } from 'motion/react'
import { Check } from 'lucide-react'
import { SectionHeading } from '../common/SectionHeading'
import { roadmap } from '../../utils/landingContent'
import type { LandingCopy } from '../../models/LandingPage'

type RoadmapSectionProps = {
  copy: LandingCopy
  reveal: object
}

export function RoadmapSection({ copy, reveal }: RoadmapSectionProps) {
  return <section id="roadmap" className="section roadmap"><div className="container"><motion.div {...reveal}><SectionHeading eyebrow="06 — ROADMAP" title={copy.roadmapTitle} sub={copy.roadmapSub}/></motion.div><div className="timeline">{roadmap.map((r,i)=><motion.article {...reveal} key={r.quarter} className={i===0?'active':''}><div className="quarter">{r.quarter}</div><span className="line-dot"/><small>{r.label}</small><ul>{r.items.map(x=><li key={x}><Check/>{x}</li>)}</ul></motion.article>)}</div></div></section>
}
